import DOMPurify from 'dompurify';

// Configure DOMPurify to allow table styling attributes
DOMPurify.addHook('uponSanitizeAttribute', (node, data) => {
  if (data.attrName === 'style' || data.attrName === 'border' ||
      data.attrName === 'cellpadding' || data.attrName === 'cellspacing' ||
      data.attrName === 'width' || data.attrName === 'height') {
    data.forceKeepAttr = true;
  }
});

// Auto-open links in a new tab: if a sanitized <a> tag doesn't already
// specify a target, default it to _blank so links typed into reason/
// condition fields actually go somewhere instead of just sitting there
// looking clickable. Paired with rel="noopener noreferrer" (required
// whenever target="_blank") so the new tab can't reach back into this one.
DOMPurify.addHook('afterSanitizeAttributes', node => {
  if (node.tagName === 'A' && node.hasAttribute('href')) {
    if (!node.hasAttribute('target')) {
      node.setAttribute('target', '_blank');
    }
    if (node.getAttribute('target') === '_blank') {
      node.setAttribute('rel', 'noopener noreferrer');
    }
  }
});

export default DOMPurify;
